import { parsePhoneNumberWithError } from 'libphonenumber-js';
import { replace, startsWith } from 'lodash';

import { env } from 'config';

const formatApiUrl = (url?: string) => {
  if (
    url &&
    env.apiUrl &&
    env.apiUrlDefault &&
    startsWith(url, env.apiUrlDefault)
  ) {
    return replace(url, env.apiUrlDefault, env.apiUrl);
  }
  return url;
};

const encodeRepeat = (value: string, times: number): string =>
  times <= 0 ? value : encodeRepeat(encodeURIComponent(value), times - 1);

const formatCardNumber = (value: string): string =>
  value.replace(/(\d{4})(?=\d)/g, '$1 ');

const formatPhone = (value: string): string => {
  try {
    const phone = parsePhoneNumberWithError(value);
    return phone?.isValid() ? phone.formatInternational() : value;
  } catch {
    return value;
  }
};

export const formatUtils = {
  formatApiUrl,
  encodeRepeat,
  formatCardNumber,
  formatPhone,
};
